export default __webpack_public_path__ + "static/media/watermark.a6f6923a.png";